module.exports = __webpack_public_path__ + "img/field-manager.afe741a2.png";